module.exports = __webpack_public_path__ + "img/cloud2_2t.0fe2dacf.png";